import { useCallback, useEffect, useState } from "react";
import { routeLocationSupportResponseMessagesGet } from "@devowl-wp/api-real-commerce";
import { __ } from "../utils/i18n.js";
import { realCommerceRequest } from "../utils/realCommerceRequest.js";
export function useSupportResponseMessages(deps) {
    if (deps === void 0) deps = [];
    const [messages, setMessages] = useState([]);
    const [responseTime, setResponseTime] = useState({
        responseTimeInMinutes: 36 * 60,
        responseTimeInMinutesProblemWithProduct: 48 * 60
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const minutesToString = useCallback((minutes)=>{
        const m = minutes % 60;
        const h = (minutes - m) / 60;
        const d = h / 24;
        if (h > 24) {
            // In 0,5 days
            const dInDotFive = Math.round(d * 2) / 2;
            return `${dInDotFive} ${__("days")}`;
        } else {
            // In hours
            return `${h.toString()}:${m < 10 ? "0" : ""}${m.toString()} ${__("hours")}`;
        }
    }, []);
    useEffect(()=>{
        setLoading(true);
        realCommerceRequest({
            location: routeLocationSupportResponseMessagesGet
        }).then((response)=>{
            setResponseTime(response.responseTime);
            setMessages(response.messages);
            setError(null);
        }).catch((e)=>{
            setError(e);
        }).finally(()=>{
            setLoading(false);
        });
    }, [
        ...deps
    ]);
    return {
        messages,
        responseTime,
        loading,
        error,
        minutesToString
    };
}
